import nsBrowser from '@netsapiens/netsapiens-js/dist/browser';

import pack from '../../package.json';
import createReducer from './_createReducerHelper';

export const CONFIG = 'configs/CONFIG';

const ns = pack.config.nsSocketURLs;
const ua = pack.config.uaSocketURLs;
const nsSocketURLs = [];
const uaSocketURLs = [];

if (ns.length) {
  for (let i = 0; i < ns.length; i += 1) {
    nsSocketURLs.push(`wss://${ns[i].replace('*', window.location.hostname)}`);
  }
}

if (ua.length) {
  for (let i = 0; i < ua.length; i += 1) {
    uaSocketURLs.push(`wss://${ua[i].replace('*', window.location.hostname)}`);
  }
}
const initialState = {
  appName: pack.name,
  apiURL: `https://${pack.config.apiURL.replace('*', window.location.hostname)}`,
  appURL: `https://${pack.config.appURL.replace('*', window.location.hostname)}`,
  devicePostFix: pack.config.devicePostFix,
  hostname: window.location.hostname,
  nsSocketURLs,
  pathname: window.location.pathname,
  portalURL: `https://${pack.config.portalURL.replace('*', window.location.hostname)}`,
  protocol: window.location.protocol,
  supportedBrowsers: pack.config.supportedBrowsers,
  uaSocketURLs,
  userId: nsBrowser.getQuery('user'),
  version: pack.version,
};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [CONFIG]: (state, { payload }) => ({ ...state, ...payload }),
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param {*} config
 * @return {{type, payload: {}}}
 */
export const setConfig = (config) => ({
  type: CONFIG,
  payload: config,
});

/** ********************************************
 * selectors
 ******************************************** */

/**
 *
 * @param state
 * @return {Array}
 */
export const selectBrowsers = (state) => {
  const browsers = [
    'ChromeSupport',
    'FirefoxSupport',
    'IESupport',
    'EdgeSupport',
    'SafariSupport',
  ];

  const tmp = [];
  for (let i = 0; i < browsers.length; i += 1) {
    let val = state.configs[browsers[i]];
    if (val) {
      val = Number.parseInt(val, 10);
      if (!Number.isNaN(val)) {
        tmp.push({ configName: browsers[i], val });
      }
    }
  }

  return tmp;
};

/**
 *
 * @param state
 * @return {*|{}}
 */
export const selectConfigs = (state) => state.configs || {};

/**
 *
 * @param state
 * @param name
 * @return {*|null}
 */
export const selectConfig = (state, name) => state.configs[name] || null;
